import 'core-js/features/array/at'

import { showDirectoryPicker, showOpenFilePicker, showSaveFilePicker } from 'file-system-access'
import UAParser from 'ua-parser-js'

const userAgentParser = new UAParser(window.navigator.userAgent)
const browser = userAgentParser.getBrowser()

if (['Mozilla', 'Firefox'].includes(browser.name ?? '')) {
  navigator.serviceWorker.register('/sw.js')
}

// @ts-expect-error Это API есть только в хромподбных браузерах
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
window.showOpenFilePicker ??= showOpenFilePicker
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
window.showDirectoryPicker ??= showDirectoryPicker
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
window.showSaveFilePicker ??= showSaveFilePicker
